interface StarRatingProps {
  rating: number;
  showValue?: boolean;
  size?: 'sm' | 'md';
}

export default function StarRating({ rating, showValue = true, size = 'sm' }: StarRatingProps) {
  const iconSize = size === 'sm' ? 'text-xs' : 'text-sm';
  return (
    <span className="inline-flex items-center gap-1">
      <i className={`ri-star-fill text-accent-500 ${iconSize}`} aria-hidden="true" />
      {showValue && (
        <span className={`font-label font-semibold text-foreground-800 ${size === 'sm' ? 'text-xs' : 'text-sm'}`}>
          {rating.toFixed(1)}
        </span>
      )}
    </span>
  );
}